import { useEffect } from "react";

function OpenBillsPageOnFallback() {
  useEffect(() => {
    window.location.replace(
      "https://play.google.com/store/apps/details?id=com.ono.ono_flutter"
    );
  }, []);

  return null;
}

export default OpenBillsPageOnFallback;
